/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText, Grid } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import dayjs from 'dayjs';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "SUPPLIERPAYMENTVERIFICATION"

export default function SupplierPaymentVerificationReportView(props) {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Supplier Payment Verification Report'
    });
    const [datevalue, setDateValue] = useState(new Date());
    const [toDatevalue, setToDateValue] = useState(new Date());
    const [product, setProduct] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [supplierVerificationDetails, setSupplierVerificationDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [grnData, setgrnData] = useState({
        grnName: ''
    });
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        date: null
    });
    const [totalCals, setTotalCals] = useState({
        totalAmount: 0,
        totalSuccess: 0,
        totalPending: 0,
        totalFailed: 0
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        operationEntityName: '',
        date: '',

    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const successTotal = supplierVerificationDetails.reduce((total, row) => row.status === 2 ? total + parseFloat(row.txnAmount) : total, 0);
    const pendingTotal = supplierVerificationDetails.reduce((total, row) => row.status === 1 ? total + parseFloat(row.txnAmount) : total, 0);
    const failedTotal = supplierVerificationDetails.reduce((total, row) => row.status !== 2 && row.status !== 1 ? total + parseFloat(row.txnAmount) : total, 0);
    const classes = useStyles();
    const supplierVerificationReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.array()
            .min("1", 'Please select at least one Fresh collection center')
            .required('Please select at least one Fresh collection center'),
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            date: datevalue,
            toDate: toDatevalue,
        },

        validationSchema: supplierVerificationReportSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
            setIsHidden(true)
        }
    });

    async function SubmitForm(values) {
        let model = {
            groupID: parseInt(values.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            date: new Date(datevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString().split('T')[0]
        }
        var res = await services.SupplierPayementVerificationReportDetails(model)
        let totalAmount = 0;
        let successAmount = 0;
        let pendingAmount = 0;
        let failedAmount = 0;

        res.forEach(x => {
            totalAmount += parseFloat(x.txnAmount)
            if (x.status == 2) {
                successAmount += parseFloat(x.txnAmount)
            } else if (x.status === 1) {
                pendingAmount += parseFloat(x.txnAmount)
            } else {
                failedAmount += parseFloat(x.txnAmount)
            }
        });

        setTotalCals({
            ...totalCals,
            totalAmount: totalAmount,
            totalSuccess: successAmount,
            totalPending: pendingAmount,
            totalFailed: failedAmount
        })
        setPage(0);
        setSupplierVerificationDetails(res);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (permissionList.isFactoryFilterEnabled) {
            setDateValue(new Date());
            setToDateValue(new Date());
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
                datevalue: datevalue.toISOString().split('T')[0],
                toDatevalue: toDatevalue.toISOString().split('T')[0],
            })
            setSupplierVerificationDetails([]);
            setSelectedOptions([]);
            setSelectedCategoryOptions([]);
            setSelectedProductOptions([]);
        } else {
            setSupplierVerificationDetails([]);
        }
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    function getSelectedDropdownValuesForReport() {
        var grpname
        {
            group.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        var operationentityname
        {
            factory.map((x) => (
                x.factoryID == formik.values.operationEntityID ? operationentityname = x.factoryName : null
            ))
        }

        var productName
        {
            product.map((x) => (
                x.productID == formik.values.productID ? productName = x.productName : null
            ))
        }

    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetVCCFactoriesByGroupID(formik.values.groupID);
        var newOptionArray = [];
        for (var i = 0; i < res.length; i++) {
            newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
        }
        setOperationEntityList(newOptionArray);
    }

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
    }, [formik.values.collectionCenterID]);

    useEffect(() => {
        getPermissions();
        trackPromise(GetProductDetails());
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        setSupplierVerificationDetails([]);
    }, [formik.values.groupID, formik.values.operationEntityID, formik.values.productID, formik.values.date])

    useEffect(() => {
        setSupplierVerificationDetails([]);
    }, [datevalue]);

    useEffect(() => {
        setSupplierVerificationDetails([]);
    }, [toDatevalue]);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        setSupplierVerificationDetails([]);
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        setSelectedOptions([]);
    }, [formik.values.groupID]);

    useEffect(() => {
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productID: selectedProductOptions,
            productCategoryID: selectedCategoryOptions,
        })
    }, [selectedOptions, selectedProductOptions, selectedCategoryOptions]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - supplierVerificationDetails.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectChange = (event) => {
        const selectedValues = event.target.value;
        if (selectedValues.includes('')) {
            setSelectedOptions(
                selectedOptions.length === operationEntityList.length
                    ? []
                    : operationEntityList.map((option) => option.value)
            );
        } else {
            setSelectedOptions(selectedValues);
        };
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERPAYMENTVERIFICATION');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(supplierVerificationDetails);

        var settings = {
            sheetName: 'SPV Report',
            fileName: 'Supplier Payment Verification Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'SPV Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                const benBranchCode = x.benBranchCode.toString().padStart(3, '0');
                const debitBranchCode = x.debitBranchCode.toString().padStart(3, '0');
                var vr = {
                    'TransactionID': x.transactionID,
                    'Farmer Code': x.farmerCode,
                    'InvoiceNumber': x.invoiceNumber,
                    'Beneficiary Bank Code': x.benBankCode,
                    'Beneficiary Branch Code': benBranchCode,
                    'Beneficiary Acc No': x.benAccNo,
                    'Beneficiary Acc Name': x.benAccName,
                    'Amount': parseFloat(x.txnAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Debit Bank Code': x.debitBankCode,
                    'Debit Branch Code': debitBranchCode,
                    'Debit Acc No': x.debitAccNo,
                    'Debit Acc Name': x.debitAccName,
                    'Document No': x.sequenceNumber,
                    'Posting Date': moment(x.postingDate).format("YYYY-MM-DD"),
                    'Status': x.status === 2 ? "Success" : x.status === 1 ? "Pending" : "Failed",
                    'Status Code': x.statusCode === null ? " " : x.statusCode,
                    'Status Description': x.statusDescription === null ? " " : x.statusDescription,
                    'Status Update Date': x.statusUpdateDate === null ? "-" : moment(x.statusUpdateDate).format("YYYY-MM-DD"),
                }
                res.push(vr);
            });
            var vr2 = {
                'TransactionID': 'Total',
                'Amount': parseFloat(totalCals.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr2);

            var vr3 = {
                'TransactionID': 'Success Total',
                'Farmer Code': parseFloat(successTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr3);

            var vr4 = {
                'TransactionID': 'Pending Total',
                'Farmer Code': parseFloat(pendingTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr4);

            var vr5 = {
                'TransactionID': 'Failed Total',
                'Farmer Code': parseFloat(failedTotal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            }
            res.push(vr5);
        }
        return res;
    }


    function getSelectedDropdownValuesForReport() {
        let groups = groupList.find(x => x.groupID == formik.values.groupID)
        const facName = [];
        const proName = [];
        selectedOptions.forEach(x => {
            const fildered = operationEntityList.find(y => x === y.value).label
            facName.push(fildered)
        });
        selectedProductOptions.forEach(x => {
            const fildered = product.find(y => x === y.value).label
            proName.push(fildered)
        });
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups.groupName,
            operationEntityName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(','),
            productName: proName.length == 0 ? 'All Crops' : proName.join(','),
            date: new Date(datevalue).toISOString().split('T')[0],
            toDate: new Date(toDatevalue).toISOString().split('T')[0]
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options';
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Supplier Payment Verification Report  |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack>
                                    <Grid>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {groupList.map((option) => (
                                                    option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem> : null
                                                ))}
                                            </TextField>

                                            <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                                <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                                <Select
                                                    className="custom-select"
                                                    labelId="multi-select-label"
                                                    id="multi-select"
                                                    multiple
                                                    size="small"
                                                    value={selectedOptions}
                                                    onChange={handleSelectChange}
                                                    label="Fresh Collection Center "
                                                    disabled={!permissionList.isFactoryFilterEnabled}
                                                    renderValue={(selected) => renderSelectedValue(selected)}
                                                >
                                                    <MenuItem key={0} value={''}>
                                                        <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                        All Fresh Collection Center
                                                    </MenuItem>
                                                    {operationEntityList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {touched.operationEntityID && errors.operationEntityID && (
                                                    <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                                )}
                                                {selectedOptions.length > 0 && (
                                                    <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                        {!permissionList.isFactoryFilterEnabled ? null :
                                                            <ClearIcon />}
                                                    </IconButton>
                                                )}
                                            </FormControl>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    size="small"
                                                    label="From Date *"
                                                    openTo="day"
                                                    type="date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={datevalue}
                                                    onChange={(newValue) => {
                                                        setDateValue(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                        />
                                                    )}
                                                    maxDate={dayjs()}
                                                />
                                            </LocalizationProvider>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    size="small"
                                                    label="To Date *"
                                                    openTo="day"
                                                    type="date"
                                                    inputFormat="MM/DD/YYYY"
                                                    value={toDatevalue}
                                                    onChange={(newValue) => {
                                                        setToDateValue(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                        />
                                                    )}
                                                    maxDate={dayjs()}
                                                />
                                            </LocalizationProvider>
                                        </Stack>
                                    </Grid>
                                    <div>
                                        <br />
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error"
                                                onClick={() => clearAll()}
                                            >
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined"
                                            >
                                                Search
                                            </Button>
                                        </Stack>
                                    </div>
                                </Stack>
                                <br />
                                {isEnable == false ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={grnData.grnName}
                                            placeholder="Search"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Stack> : null}
                                {supplierVerificationDetails.length != 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Card style={{ justifycontent: 'center', width: '120rem' }} >
                                            <TableContainer component={Paper} >
                                                <Table aria-label="simple table" size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left">TransactionID</TableCell>
                                                            <TableCell align='left'>Farmer Code</TableCell>
                                                            <TableCell align="left">InvoiceNumber</TableCell>
                                                            <TableCell align="left">Beneficiary&nbsp;Bank Code</TableCell>
                                                            <TableCell align="left">Beneficiary&nbsp;Branch Code</TableCell>
                                                            <TableCell align="left">Beneficiary&nbsp;Acc No</TableCell>
                                                            <TableCell align="left">Beneficiary&nbsp;Acc Name</TableCell>
                                                            <TableCell align="right">Amount</TableCell>
                                                            <TableCell align="left">Debit&nbsp;Bank Code</TableCell>
                                                            <TableCell align="left">Debit&nbsp;Branch Code</TableCell>
                                                            <TableCell align="left">Debit&nbsp;Acc No</TableCell>
                                                            <TableCell align="left">Debit&nbsp;Acc Name</TableCell>
                                                            <TableCell align="left">Document No</TableCell>
                                                            <TableCell align="left">Posting&nbsp;Date</TableCell>
                                                            <TableCell align="left">Status</TableCell>
                                                            <TableCell align="left">Status&nbsp;Code</TableCell>
                                                            <TableCell align="left">Status&nbsp;Description</TableCell>
                                                            <TableCell align="left">Status&nbsp;Update Date</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? supplierVerificationDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : supplierVerificationDetails
                                                        ).map((row) => {
                                                            const isSuccess = row.status === 2;
                                                            const benBranchCode = row.benBranchCode.toString().padStart(3, '0');
                                                            const debitBranchCode = row.debitBranchCode.toString().padStart(3, '0');
                                                            return (
                                                                <TableRow key={row.TransactionID}>
                                                                    <TableCell align="left">{row.transactionID}</TableCell>
                                                                    <TableCell align='left'>{row.farmerCode}</TableCell>
                                                                    <TableCell align="left">{row.invoiceNumber}</TableCell>
                                                                    <TableCell align="left">{row.benBankCode}</TableCell>
                                                                    <TableCell align="left">{benBranchCode}</TableCell>
                                                                    <TableCell align="left">{row.benAccNo}</TableCell>
                                                                    <TableCell align="left">{row.benAccName}</TableCell>
                                                                    <TableCell align="right">{parseFloat(row.txnAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="left">{row.debitBankCode}</TableCell>
                                                                    <TableCell align="left">{debitBranchCode}</TableCell>
                                                                    <TableCell align="left">{row.debitAccNo}</TableCell>
                                                                    <TableCell align="left">{row.debitAccName}</TableCell>
                                                                    <TableCell align="left">{row.sequenceNumber}</TableCell>
                                                                    <TableCell align="left">{moment(new Date(row.postingDate)).format('YYYY-MM-DD')}</TableCell>
                                                                    <TableCell align="left">{row.status === 2 ? 'Success' : row.status === 1 ? 'Pending' : 'Failed'}</TableCell>
                                                                    <TableCell align="left">{row.statusCode === null ? '-' : row.statusCode}</TableCell>
                                                                    <TableCell align="left">{row.statusDescription === null ? '-' : row.statusDescription}</TableCell>
                                                                    <TableCell align="left">{row.statusUpdateDate === null ? '-' : moment(new Date(row.statusUpdateDate)).format('YYYY-MM-DD')}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={20} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TableCell align="left"><b>Total</b></TableCell>
                                                            <TableCell colSpan={6} />
                                                            <TableCell align="right"><b>{parseFloat(totalCals.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                                            <TableCell colSpan={9} />
                                                        </TableRow>
                                                        <br></br>
                                                        <TableRow>
                                                            <TableCell align="left"><b>Success Total</b></TableCell>
                                                            <TableCell align="right"><b>{successTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                                            <TableCell colSpan={16} />
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left"><b>Pending Total</b></TableCell>
                                                            <TableCell align="right"><b>{pendingTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                                            <TableCell colSpan={16} />
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="left"><b>Failed Total</b></TableCell>
                                                            <TableCell align="right"><b>{failedTotal.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                                            <TableCell colSpan={16} />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                count={supplierVerificationDetails.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    inputProps: {
                                                        'aria-label': 'rows per page',
                                                    },
                                                    native: true,
                                                }}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                ActionsComponent={TablePaginationActions}
                                            />
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="Supplier Payment Verification Report" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {supplierVerificationDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Supplier Payment Verification Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    supplierVerificationDetails={supplierVerificationDetails}
                                    searchData={selectedSearchValues}
                                    totalCals={totalCals}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}
